import { Component, OnInit, ViewChild } from '@angular/core';
import { MasterDTO } from '../../model/admin.entity';
import { Table } from 'primeng/table';
import { AdminService } from '../../services/admin.service';
import { CommonService } from '../../../core/common/services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { MasterDataRepository } from '../../../core/data/repositories/masterdata.repository';

@Component({
  selector: 'tandc-supporting-construction',
  templateUrl: './supporting-construction.component.html'
})
export class SupportingConstructionComponent  implements OnInit{

  SupportingConstructionList: MasterDTO[] = [];
  SupportingConstructionModal: MasterDTO = new MasterDTO();
  showModal: boolean = false;
  modalTitle: string = '';
  @ViewChild('dt')
  dt!: Table;
 
  constructor(
    private service: AdminService,
    private commonService: CommonService,
    private translate: TranslateService,
    private masterDataRepository: MasterDataRepository
  ) { }
 
  ngOnInit(): void {
    this.getAll();
  }
 
  applyFilterGlobal($event: any, stringVal: any) {
    this.dt!.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }
 
  getAll() {
    try {
      this.service.getSupportingConstruction().subscribe((x) => {
      this.SupportingConstructionList = x.value;
    });
    } catch (error) {
      console.log(error.message);
    }
  }
 
  addModal() {
    this.SupportingConstructionModal = new MasterDTO();
    this.showModal = !this.showModal;
    this.modalTitle =
      this.translate.instant('commonbtn.add') +
      ' ' +
      this.translate.instant('Master.supportingConstruction');
  }
 
  save(data: MasterDTO) {
    if (data.id > 0) {
      this.service.updateSupportingConstruction(data).subscribe((res) => {
        if (res) {
          this.showModal = !this.showModal;
          this.commonService.successMessage(
            this.translate.instant('Alerts.UpdatedSuccessfully')
          );
          this.getAll();
        }
      });
    } else {
      this.service.saveSupportingConstruction(data).subscribe((res) => {
        if (res) {
          this.showModal = !this.showModal;
          this.commonService.successMessage(
            this.translate.instant('Alerts.SavedSuccessfully')
          );
          this.getAll();
        }
      });
    }
  }
 
  delete(data: MasterDTO) {
    this.commonService.confirmationService.confirm({
      message: this.translate.instant('Alerts.DeleteConfirmation'),
      accept: () => {
        if (data) {
          this.service.deletesupportingConstruction(data.id).subscribe((res) => {
            if (res) {
              this.commonService.successMessage(
                this.translate.instant('Alerts.DeleteSuccessfully')
              );
              this.getAll();
            }
          });
        }
      },
    });
  }

    onToggleStatus(item: MasterDTO) {
  const updatedItem = { ...item }; 
  this.service.updateSupportingConstruction(updatedItem).subscribe({
    next: () => {
      this.commonService.successMessage(
        this.translate.instant('Alerts.UpdatedSuccessfully')
      );
    },
    error: () => {
      this.commonService.errorMessage(
        this.translate.instant('Alerts.ErrorOccured')
      );
      // Revert toggle on error
      item.isActive = !item.isActive;
    }
  });
  }
 
  edit(data: MasterDTO) {
    this.modalTitle = this.translate.instant('common.update') + ' ' + this.translate.instant('Master.supportingConstruction');
    this.SupportingConstructionModal = data;
    this.showModal = !this.showModal;
  }

    downloadFile(blob: Blob, fileName: string): void {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  export() {
    this.masterDataRepository.export('supporting-construction').subscribe(blob => {
      this.downloadFile(blob, `supporting-construction-${new Date().toISOString().slice(0,10)}.xlsx`);
    });
  }
}
